import BillingInformation from "views/BillingInformation";
import Dashboard from "views/Dashboard";
import OrderDetails from "views/OrderDetails/OrderDetails";
import TrademarkSearch from "views/OrderDetails/TrademarkSearch";
import PersonalInformation from "views/PersonalInformation";
import Specimen from "views/OrderDetails/Specimen";
import RequiredActionDetails from "views/OrderDetails/RequiredActionDetails";
import MonitoringReports from "views/OrderDetails/MonitoringReports";
import AssessmentReport from "views/OrderDetails/AssessmentReport";
import LogoDesignRevision from "views/OrderDetails/LogoDesignRevision";
// import UpsellPage from "views/UpsellPage";
// import UpsellSelectPage from "views/UpsellSelectPage";
import Subscriptions from "components/Subscriptions/Subscriptions";
import SubscriptionDetails from "components/Subscriptions/SubscriptionDetails";

const dashboardRoutes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/user",
    name: "Personal Information",
    component: PersonalInformation,
  },
  {
    path: "/billing-info",
    name: "Billing Information",
    component: BillingInformation,
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    component: Subscriptions,
  },
  {
    path: "/subscriptions/:orderId",
    name: "Subscription Details",
    component: SubscriptionDetails,
  },
  {
    path: "/subscriptions/:orderId/:productId",
    name: "Subscription Details",
    component: SubscriptionDetails,
  },
  {
    path: "/orders/:orderId",
    name: "Order Details",
    component: OrderDetails,
  },
  {
    path: "/orders/:orderId/search",
    name: "Trademark Search",
    component: TrademarkSearch,
  },
  {
    path: "/orders/:orderId/specimen",
    name: "Specimen",
    component: Specimen,
  },
  {
    path: "/orders/:orderId/action/:actionId",
    name: "Required Action",
    component: RequiredActionDetails,
  },
  {
    path: "/orders/:orderId/monitoring",
    name: "Monitoring Report",
    component: MonitoringReports,
  },
  {
    path: "/orders/:orderId/assessment",
    name: "Assessment Report",
    component: AssessmentReport,
  },
  {
    path: "/orders/:orderId/revision",
    name: "Logo Design Revision",
    component: LogoDesignRevision,
  },
  // {
  //   path: "/upsell",
  //   name: "Upsell",
  //   component: UpsellSelectPage,
  // },
  // {
  //   path: "/upsell/:productCode/order/:orderId",
  //   name: "Upsell",
  //   component: UpsellPage,
  // },
  // {
  //   path: "/upsell/:productCode",
  //   name: "Upsell",
  //   component: UpsellSelectPage,
  // },
];

export default dashboardRoutes;
